import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Bubble, Dropdown, Popover, Radio } from 'tea-component';
import { capitalize, find, get, isEmpty } from 'lodash-es';
import DataSummaryType from '@/pages/aigc/assets/svg/dataSummaryType.svg';
import Date from '@/pages/aigc/assets/svg/date.svg';
import {useCachedState} from '@/pages/aigc/hooks/useCachedState';

export const DataSummaryCardTypeView = ({ data, formatMessage }: any) => {
  const icon = {
    date: Date,
  } as const;
  return (
    <div className="dbi-DataAnalysis-summaryContainer">
      {data?.map((task) => (
        <div
          key={task.column}
          className="dbi-DataAnalysis-summaryContainer-item"
        >
          <div className="dbi-DataAnalysis-summaryContainer-item-name">
            <img
              src={icon?.[task.properties?.dtype] || DataSummaryType}
              alt=""
            />
            <span>{capitalize(task.column)}</span>
          </div>
          {task.properties?.dtype && (
            <div className="dbi-DataAnalysis-summaryContainer-item-type">
              {task.properties?.dtype} &nbsp;|
            </div>
          )}
          <div className="dbi-DataAnalysis-summaryContainer-item-value">
            <span className="deadColour">
              # {formatMessage('unique_values')}:{' '}
            </span>
            {task.properties?.num_unique_values || '-'}
          </div>
          <Bubble
            dark
            placement="right-start"
            content={
              <>
                <div>
                  {formatMessage('min')}: {task.properties?.max}
                </div>
                <div>
                  {formatMessage('max')}: {task.properties?.min}
                </div>
                <div>
                  {formatMessage('std')}: {task.properties?.std?.toFixed(3)}
                </div>
              </>
            }
          >
            <div className="dbi-DataAnalysis-summaryContainer-item-unit">
              {(task.properties?.min || task.properties?.min === 0) && (
                <>
                  <span className="deadColour">{formatMessage('min')}:</span>
                  {task.properties?.min},&nbsp;
                </>
              )}
              {task.properties?.max && (
                <>
                  <span className="deadColour">{formatMessage('max')}:</span>
                  {task.properties?.max}
                </>
              )}
              {task.properties?.std && (
                <>
                  <span className="deadColour">
                    &nbsp;|&nbsp;{formatMessage('std')}:
                  </span>
                  {task.properties?.std.toFixed(3)}
                </>
              )}
            </div>
          </Bubble>
          <div className="dbi-DataAnalysis-summaryContainer-item-select">
            <Dropdown
              matchButtonWidth
              clickClose={false}
              style={{ marginRight: 10, width: '100%' }}
              button={formatMessage('view')}
              appearance="button"
              className="samples-container"
            >
              <div
                style={{
                  display: 'flex',
                  padding: '15px',
                  flexWrap: 'wrap',
                }}
              >
                {task.properties?.samples.map((task) => (
                  <div
                    style={{
                      marginRight: '8px',
                      borderRadius: '4px',
                      background: '#f5f5f8',
                      border: '1px solid #d8dae4',
                      padding: '8px 16px',
                      marginBottom: '10px',
                    }}
                  >
                    {task}
                  </div>
                ))}
              </div>
            </Dropdown>
          </div>
        </div>
      ))}
    </div>
  );
};
export const GoalExplorationCardTypeView = ({ data, visualizeAsync }: any) => {
  const [ix, setTaste, resetCache] = useCachedState<string>( 'db_lida_goal_type', '0',);
  const handleEditExplorationIndex = (index: number) => {
    setTaste( `${index  }` );
    const dialogueMessages = find(
      data,
      (_, taskIndex) => +taskIndex === +index,
    );
    visualizeAsync({
      goal: dialogueMessages,
    });
  };

  return (
    <div className="dbi-DataAnalysis-explorationContainer">
      {data?.map((task, index) => (
        <div
          key={index}
          onClick={() => handleEditExplorationIndex(index)}
          className={classNames('dbi-DataAnalysis-explorationContainer-item', {
            'dbi-DataAnalysis-explorationContainer-item-line': index === +ix,
          })}
        >
          <div className="dbi-DataAnalysis-explorationContainer-item-header">
            {/* <div className="dbi-DataAnalysis-explorationContainer-item-header-left"> */}
            <Radio.Group className="dbi-filter-radio" value={ix}>
              <Radio name={`${index  }`} />
            </Radio.Group>
            {/* </div> */}
            {/* <span className="dbi-DataAnalysis-explorationContainer-item-header-index">
              {index + 1}
            </span>
            <span className="dbi-DataAnalysis-explorationContainer-item-header-title">
                {task.question}
              </span> */}
            <div className="dbi-DataAnalysis-explorationContainer-item-header-right">
              <span>{index + 1}</span>
              <div className="right-text">{task.question}</div>
            </div>
          </div>
          <div className="dbi-DataAnalysis-explorationContainer-item-type">
            {task.visualization}
          </div>
          <div className="dbi-DataAnalysis-explorationContainer-item-description">
            {task.rationale}
          </div>
        </div>
      ))}
    </div>
  );
};
